import { FC } from 'react';

import { Box } from '@mantine/core';

const DCIDEController: FC<{
    width?: number;
    height?: number;
    color?: string;
}> = ({ width, height, color = 'black' }) => {
    return (
        <Box component="svg" viewBox="0 0 940 228" width={width} height={height} fill={color}>
            <path
                fillRule="evenodd"
                d="M736.885 99.54c0-8.507 6.994-15.475 15.533-15.475h19.985l13.353-26.513h-33.247c-23.255 0-42.149 18.822-42.149 41.987s18.894 41.988 42.149 41.988H940v-26.514H752.418c-8.63 0-15.533-6.877-15.533-15.474Z"
                clipRule="evenodd"
            />
            <path d="M939.818.09h-209.11v26.514h209.11V.091Z" />
            <path
                fill="#26A9E0"
                fillRule="evenodd"
                d="m809.101 57.552-13.263 26.513h44.33l13.353-26.513zm54.594 26.513h44.33l13.353-26.513h-44.329z"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M631.239 0h-137.53v26.514h137.53c24.526 0 44.329 19.817 44.329 44.159s-19.893 44.159-44.329 44.159h-137.53v26.514h137.53c39.242 0 71.036-31.672 71.036-70.764S670.481 0 631.239 0M290.684 114.922c-24.526 0-44.329-19.817-44.329-44.159s19.803-44.25 44.329-44.25h137.53V0h-137.53c-39.242 0-71.036 31.672-71.036 70.763s31.794 70.764 71.036 70.764h137.53v-26.514h-137.53zM137.621 0H0v26.514h137.53c24.526 0 44.329 19.817 44.329 44.159s-19.893 44.159-44.329 44.159H0v26.514h137.53c39.242 0 71.036-31.672 71.036-70.764S176.772 0 137.621 0"
                clipRule="evenodd"
            />
            <path d="M474.269 0h-26.616v141.436h26.616z" />
            <path
                fillRule="evenodd"
                d="M38 168h-8a30 30 0 0 0 0 60h55v-11.248H30a18.752 18.752 0 0 1 0-37.504h2.376Zm90.778 0h25a30 30 0 0 1 0 60h-25a30 30 0 0 1 0-60m0 11.248h25a18.752 18.752 0 0 1 0 37.504h-25a18.752 18.752 0 0 1 0-37.504M197.556 168h17l56.752 50.075V168h11.248v60h-17.001l-56.752-50.075V228h-11.247Zm98.777 0h85v11.248h-36.876V228h-11.248v-48.752h-36.876Zm98.778 0h67.169a17.831 17.831 0 0 1 0 35.662L474.449 228h-12.576l-12.169-24.338h-43.345V228h-11.248Zm11.248 11.248h55.921a6.583 6.583 0 0 1 0 13.167h-55.921ZM523.889 168h25a30 30 0 0 1 0 60h-25a30 30 0 0 1 0-60m0 11.248h25a18.752 18.752 0 0 1 0 37.504h-25a18.752 18.752 0 0 1 0-37.504M592.667 168h11.247v48.752h56.753V228h-68Zm81.777 0h11.248v48.752h56.752V228h-68Zm91.111 0h75.667v11.248h-75.667Zm75.667 60h-67.207a17.793 17.793 0 0 1 0-35.585h10.907l-5.624 11.247h-5.283a6.545 6.545 0 0 0 0 13.09h67.207ZM855 168h67.169a17.831 17.831 0 0 1 0 35.662L934.338 228h-12.576l-12.169-24.338h-43.345V228H855Zm11.248 11.248h55.921a6.583 6.583 0 0 1 0 13.167h-55.921Z"
                clipRule="evenodd"
            />
            <path
                fill="#26A9E0"
                d="M46 168h15.5l-5.624 11.248h-15.5Zm23.5 0H85l-5.624 11.248h-15.5Zm723.122 24.415h14.5l-5.624 11.247h-14.5Zm22.2 0h14.5l-5.624 11.247h-14.5Z"
            />
        </Box>
    );
};

export { DCIDEController };
